export default {"src":"/org/_next/static/media/dot.e4d2399a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};